<template>
	<section>
		<header-page
			name="todos"
			:title="$route.meta.title"
		/>
		<todo-list
			:columns="columns"
			:current-page="currentPage"
			:rows="table.rows"
			:last-page="table.lastPage"
			@change-page="changePage"
			@on-search="onSearch($event, 'todos')"
		/>
		<quick-actions
			v-if="$route.name === 'page-todo'"
			:actions="actions"
			@open-modal="openModal"
		>
		</quick-actions>
		<router-view></router-view>
	</section>
</template>

<script>
import quickActions from '@/components/shared/quick-actions';
import todoList from '@/components/todos/todo-list';

function created() {
	this.loadData('todos');
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.loadData('todos');
}

function data() {
	return {
		actions: [
			{
				id: 1,
				code: 'CC',
				text: 'Crear Todo',
				icon: 'playlist_add_check',
				active: true,
			},
		],
		columns: [
			{ id: 1, name: 'Id', checked: true, visible: true },
			{ id: 2, name: 'User', checked: true, visible: true },
			{ id: 3, name: 'Title', checked: true, visible: true },
			{ id: 4, name: 'Is Completed?', checked: true, visible: true },
			{ id: 5, name: 'Acciones', checked: true, visible: true },
		],
		currentPage: 1,
	};
}

function openModal() {
	this.goTo('page-todo-new');
}

export default {
	name: 'page-todo',
	created,
	components: {
		todoList,
		quickActions,
	},
	data,
	methods: {
		changePage,
		openModal,
	},
	watch: {
		$route(newVal) {
			if (newVal) {
				if (newVal.name === 'page-todo') {
					this.loadData('todos');
				}
			}
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/todos/page-todo.vue